import useSWRImmutable from 'swr/immutable';
import IntegrationService from '@/services/IntegrationService';

const useWidgetsCategories = () => useSWRImmutable(
    'widgets-categories',
    IntegrationService.getWidgetsCategories,
);

export default useWidgetsCategories;
